import NewYHConstract from '@/mixins/constracts';
import { Component, Mixins } from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'HSPreApplyContract' })
export default class HSPreApplyContract extends Mixins(NewYHConstract) {
  private render() {
    return <div class={style.HSPreApplyContract}>
      <p class={style.title}>
        <strong>
          恒生银行（中国）有限公司个人消费贷款服务说明
        </strong>
      </p>
      <br />
      <br />
      <p>
        上海钧正网络科技有限公司（以下称“哈啰出行”）与恒生银行（中国）有限公司（以下称“恒生中国”）通过臻有钱贷款服务平台共同为您提供个人消费贷款服务
      （具体请参见《个人借款授信额度合同》和《个人消费贷款合同》）。本服务说明有助于您了解哈啰出行与恒生中国在该贷款服务中所享有和承担的权利责任。
      <strong>为了保障您的合法权益，在您申请恒生中国贷款之前，请务必审慎阅读、充分理解本服务的所有内容。</strong>
      </p>

      <p>
        一. 您可透过哈啰出行的臻有钱贷款服务平台申请恒生中国个人消费贷款，哈啰出行将在
            贷款服务的合法合规必要范围内，查询、收集您有关的信息(包括但不限于您的身份信
            息、行为信息、交易信息、业务信息、设备信息、资信状况、地址信息、位置信息、
            通讯信息等)，获取您留存的姓名、身份证号码、手机号码、绑定账户账号(卡号)及身
            份证件的影印件（包括电子形式），并提供给恒生中国作为贷款审批或贷后管理使
            用。贷款审批通过后, 您可于哈啰出行平台发起提款申请、查询您账户名下的贷款记
            录、调阅贷款合同等。若您有任何咨询或投诉需求，可通过“臻有钱”在线客服咨询。
      </p>

      <p>
        二、 恒生中国将对您于在哈啰出行的臻有钱贷款服务平台申请的个人消费贷款进行审批，
            并在提款阶段完成贷款发放。恒生中国将根据审核个人消费贷款申请和贷后风险管理
            的需要，在贷款申请过程中，贷款存续期间或贷款项下任何债务未向恒生银行彻底清
            偿前，查询您个人信用记录及信用评估等必要信息。请您配合签署以下《个人信用报
            告查询授权书》。贷款发放成功后，恒生中国于还款管理阶段，向您提供逾期、催收
            提醒、逾期征信上报等服务。
            因任何原因，恒生中国与哈啰出行出现合作变更或终止，您处于贷款周期内的已申请
            贷款将不会受到影响。
            若您有任何咨询或投诉需求，可通过恒生中国电话客服4008-30-8008咨询。
      </p>

      <p>
        <strong>《个人信用报告查询授权书》</strong>
      </p>
      <p>
        <strong>尊敬的用户:基于“臻有钱”贷款服务平台项下恒生银行（中国）有限公司个人消费贷款
        业务，为了维护您的权益，我们提醒您点击确认了《个人信用报告查询授权书》(以下简称
          “本授权书”)即视为您已阅读本授权书所有条款，并对本授权书各项条款的含义及相应的法
          律后果已全部通晓并充分理解，同意接受本授权书的约束。请您务必关注您在授权书中的
          权利、义务，珍惜个人信用。
        </strong>
      </p>
      <p>
        一、授权内容
      </p>
      <p>
        &nbsp;授权人(亦称“本人”)同意向恒生银行（中国）有限公司 上海分行(以下简称“被授权人”或“恒
        生银行”)郑重授权如下:
        &nbsp;1. 授权人特委托并授权恒生银行根据审核个人消费贷款申请和贷后风险管理的需要，在贷款
        款申请过程中，贷款存续期间或贷款项下任何债务未向恒生银行彻底清偿前（合称为“授权
        期限”），不时向中国人民银行金融信用信息基础数据库或其他征信机构查询授权人个人信
        用记录及信用评估信息。为此目的，授权人授权恒生银行进入中国人民银行金融信用信息
        基础数据库或其他征信机构查询个人信用报告，并向中国人民银行金融信用信息基础数据
        库或其他征信机构报送授权人的信用信息，包括若授权人发生贷款逾期，恒生银行将向中
        国人民银行金融信用信息基础数据库或其他征信机构报送逾期信息，并以通知函的方式告知授权人。
      </p>
      <p>
        &nbsp;授权人亦授权恒生银行根据审核个人消费贷款申请和贷后风险管理的需要，在授权期限向上海钧正网络科技有限公司查询、获取授权人的风险数据、圈客分、欺诈分，并保留相关信息。
      </p>
      <p>
        &nbsp;授权人亦授权恒生银行根据审核个人消费贷款申请和贷后风险管理的需要，在授权期限向同盾科技有限公司查询、获取授权人的标准指标、智信分、通用分，并保留相关信息
      </p>
      <p>
        &nbsp;授权人亦授权恒生银行根据审核个人消费贷款申请和贷后风险管理的需要，在授权期限向北京鼎泰智源科技有限公司查询、获取授权人的“关键词查询”情况，并保留相关信息。
      </p>
      <p>
        &nbsp;授权人亦授权恒生银行根据审核个人消费贷款申请和贷后风险管理的需要，在授权期限向中国银联股份有限公司查询、获取授权人的银联卡交易情况，并保留相关信息。
      </p>
      <p>
        &nbsp;授权人亦授权百行征信有限公司在授权期限可以向百行征信有限公司的相关股东采
        集、查询或验证授权人与贷款申请和贷后风险管理相关的信息，包括但不限于借贷信息、
        逾期信息、被催收信息以及被诉讼被执行信息等，并可将采集或查询到的授权人信息在恒
        生银行审核个人贷款申请和贷后风险管理需要时向恒生银行提供。
      </p>
      <p>
        &nbsp;授权人亦授权恒生银行根据审核个人贷款申请和贷后风险管理的需要，在授权期限不
        时向睿智合创（北京）科技有限公司查询授权人“FICO大数据评分”。
      </p>
      <p>
        &nbsp;授权人亦授权睿智合创（北京）科技有限公司在授权期限可以向依法设立的电信运营商、中国银联等第三方机
        构，查询或验证授权人与贷款申请和贷后风险管理相关的个人信息，包括授权人的手机套
        餐、话费、在网时长、消费数据等信息，并可将查询到或验证的授权人信息在恒生银行审
        核个人贷款申请和贷后风险管理需要时向恒生银行提供。
      </p>
      <p>
        &nbsp;授权人亦授权恒生银行根据审核个人贷款申请需要，在个人贷款申请期间不时向百融
        云创科技股份有限公司、百维金科（上海）信息科技有限公司、恒智普惠（武汉）数字科
        技有限公司、浙江孚临科技有限公司、北京汇法信息技术有限公司、蚂蚁区块链科技(上
        海)有限公司查询、使用或验证授权人特殊名单、借贷意向验证、欺诈分、关系网络等级、
        信用评分、司法统计、运营商实名认证、运营商在网时长、手机号码状态、关系网络等信
        息，并保留相关信息。
      </p>

      <p>
        &nbsp;授权人同意并授权恒生银行可为自动化决策方式开展个人消费贷款申请和贷后风险管
        理目的，收集、使用或以其他方式处理本人的身份信息、财产信息、信用信息、社交行为
        信息、消费行为信息、设备信息及其他资料。本业务的自动化决策是指通过计算机程序自
        动分析、评估本人的还款能力与还款意愿，并进行贷款审批决策的活动。
      </p>

      <p>
        &nbsp;授权人知悉并同意，恒生银行为审核个人贷款申请和贷后风险管理的需要可以收集、
        加工、使用、存储本人的身份信息、财产信息、账户信息及信用信息等个人信息。授权人
        同时知悉可进一步访问恒生银行网站公示的《个人信息及隐私保护政策》以了解或主张个
        人信息权利（本授权书涉及的第三方处理个人信息的规则请参见其通过官网或其他途径公示的隐私政策）。
      </p>

      <p>
        二、授权书的形式
        &nbsp;授权人同意本授权书以数据电文形式订立;授权人一旦在线确认本授权书，本授权书即生效。
      </p>

      <p>
        三、责任约定
        &nbsp;本人确认对本授权书的条款含义及相应的法律后果已全部知晓并充分理解。被授权人可查
        询和使用信用报告期间，不应超过本授权书授权期限终止之日。被授权人超出授权查询的
        一切后果及法律责任由被授权人承担。<br />
        &nbsp;若本人在被授权人处办理的业务未获批准，本人同意被授权人继续保留此查询授权书和相
        应身份及申请所留信息。
      </p>

      <p>
      授权人: {this.constractForm.userName || ''} <br />
      证件号码: {this.constractForm.idCard || ''} <br />
      授权书生效日期: {this.constractForm.effectiveDate || ''}<br />
      </p>
    </div>;
  }
}
